export default "__VITE_ASSET__61Cn$VXD__"